import evaluationsService from "presentation/services/reports";
import { saveAs } from 'file-saver';

export const generateGradesPDF = async (component, requestParams) => {

    component.setState({ loading: true });

    var response = await evaluationsService.generatePDF(requestParams);
    if (response.error === true) {
        component.setState({ error: true, message: 'Erro ao tentar emitir o arquivo pdf...' });
    } else {
        var blob = new Blob([response]);
        saveAs(blob, 'boletim.pdf');
    }

    component.setState({ loading: false });
}

const classroomFunctions = {
    generateGradesPDF
}

export default classroomFunctions;